<template>
    <div class="g-table-wrapper">
        <div class="table-title">
            Fakturaer hvor betalingsfristen er overskredet med {{ $store.state.config.companyMeta.settings.overdue_days }} dage
            ({{ employeeName }})
        </div>

        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="searchOptions"
            :pagination-options="paginationOptions"
            :sort-options="sortOptions"
            :styleClass="styleClass"
            v-if="!loading"
        >
            <div slot="emptystate">
                Ingen data ...
            </div>
            <template slot="table-row" slot-scope="props">
                <div v-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                    {{ props.row.description }}
                </div>
                <div v-else-if="props.column.field == 'invoice_number'" style="text-align:left;">
                    {{ props.row.invoice_number ? props.row.invoice_number : '-' }}
                </div>
                <div v-else-if="props.column.field == 'external_id'" class="table-column__external-id">
                    {{ props.row.external_id }}
                </div>
                <div v-else-if="props.column.field == 'due_at'">
                    {{ props.row.due_at | moment("DD. MMM YYYY") }}
                </div>
                <div v-else-if="props.column.field == 'amount'" style="text-align:left;">
                    {{ props.row.amount | currency }}
                </div>
                <div v-else-if="props.column.field == 'paid'" style="text-align:left;">
                    <span v-if="props.row.paid">
                        Betalt
                    </span>
                    <span v-else>
                        Ikke betalt
                    </span>
                </div>
                <div v-else-if="props.column.field == 'minuba_external_id'">
                    <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                        <i class="fas fa-eye"></i>
                    </a>
                </div>
                <div v-else :title="props.formattedRow[props.column.field]">
                    {{ props.formattedRow[props.column.field] }}
                </div>
            </template>
        </vue-good-table>

        <box-loading height="350" v-else />
    </div>
</template>

<script>
import shared from '../../../../../components/tables/projects/shared.js'
import * as invoiceService from '@/services/invoiceService'

export default {
    props: ['employeeId', 'employeeName'],
    data () {
        return {
            loading: true,
            columns: [
                { label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true },
                // { label: 'Type', field: 'type', type: 'string', width: '10%', align: 'left', sortable: true },
                { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true },
                { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true },
                { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true },
                { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true },
                { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true },
                { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }
            ],
            rows: [],
            searchOptions: {
                ...shared.searchOptions
            },
            paginationOptions: {
                ...shared.paginationOptions
            },
            sortOptions: {
                ...shared.sortOptions,
                initialSortBy: {
                    field: 'customer_name',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate,
                'responsible': this.employeeId
            }
            invoiceService.overdue(params, (response) => {
                console.log(response.data)
                this.rows = response.data
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// overdue.vue?a9c42f22